import { PropsWithChildren } from 'react'

type PricesProps = {}

export const Prices = ({ children }: PropsWithChildren<PricesProps>) => {
  return <div className="flex flex-col items-end">{children}</div>
}
